@use '../../../../design-tokens/typography/typography' as *;

@layer design-system {
  .text {
    @include typography-v2-body-sm;
    fill: var(--viz-bearish);
  }

  .textProfit {
    fill: var(--viz-bullish);
  }

  .rect {
    fill: var(--viz-bearish-soft);
  }

  .rectProfit {
    fill: var(--viz-bullish-soft);
  }
}
